/*
 * Back in stock via Klaviyo (Louises opgave 5, 24-08-2026).
 *
 * Klaviyo ligger allerede paa storefronten som app-embed, saa vi genbruger den
 * konto i stedet for at tilfoeje endnu en app. Public key laeses ud af det
 * klaviyo.js script der i forvejen loades, saa der ikke er en noegle at
 * vedligeholde to steder.
 */
(function () {
  'use strict';

  /*
   * Klaviyos gamle /onsite/components/back-in-stock/subscribe er pensioneret
   * (svarer 410 Gone, maalt 24-08-2026). Den nuvaerende client-side endpoint
   * herunder er lavet til at blive kaldt fra en browser og svarer med
   * Access-Control-Allow-Origin: *, saa den maa kaldes direkte fra storefronten.
   */
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var REVISION = '2024-10-15';

  function companyId() {
    var s = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
    if (!s) return null;
    var m = s.getAttribute('src').match(/company_id=([^&]+)/);
    return m ? m[1] : null;
  }

  function currentVariantId(root) {
    // Temaet skriver den valgte variant til URL'en og til det skjulte input.
    // URL'en er den mest paalidelige, men findes ikke foer foerste variantskift.
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (input && input.value) return input.value;
    return root.dataset.variantId || null;
  }

  class BackInStock extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.back-in-stock__toggle');
      this.panel = this.querySelector('.back-in-stock__panel');
      this.input = this.querySelector('.back-in-stock__input');
      this.submit = this.querySelector('.back-in-stock__submit');
      this.message = this.querySelector('.back-in-stock__message');

      var raw = this.querySelector('.back-in-stock__strings');
      try {
        this.strings = JSON.parse(raw.textContent);
      } catch (e) {
        this.strings = { success: 'Tak!', error: 'Noget gik galt.', invalid: 'Indtast en gyldig email.' };
      }

      this.toggle.addEventListener('click', this.onToggle.bind(this));
      this.submit.addEventListener('click', this.onSubmit.bind(this));
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); this.onSubmit(); }
      }.bind(this));

      this.watchAvailability();
      this.sync();
    }

    /*
     * Temaet slaar Laeg-i-kurv til og fra med disabled-attributten naar man
     * skifter variant. Vi lytter paa netop den attribut, saa vi ikke skal kende
     * temaets interne variant-events.
     */
    watchAvailability() {
      var btn = document.querySelector('.single-add-to-cart-button');
      if (!btn) return;
      this.cartButton = btn;
      new MutationObserver(this.sync.bind(this)).observe(btn, {
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    }

    sync() {
      if (!this.cartButton) return;
      var soldOut = this.cartButton.hasAttribute('disabled');
      this.hidden = !soldOut;
      if (!soldOut) {
        this.reset();
        return;
      }
      var id = currentVariantId(this);
      if (id && id !== this.dataset.variantId) {
        // Ny udsolgt variant valgt: ryd kvitteringen fra den forrige.
        this.dataset.variantId = id;
        this.reset();
      }
    }

    reset() {
      this.panel.hidden = true;
      this.toggle.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.message.hidden = true;
      this.message.textContent = '';
      this.message.classList.remove('is-error', 'is-success');
    }

    onToggle() {
      var open = this.panel.hidden;
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      if (open) this.input.focus();
    }

    say(text, kind) {
      this.message.textContent = text;
      this.message.hidden = false;
      this.message.classList.toggle('is-error', kind === 'error');
      this.message.classList.toggle('is-success', kind === 'success');
    }

    onSubmit() {
      var email = (this.input.value || '').trim();
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        this.say(this.strings.invalid, 'error');
        this.input.focus();
        return;
      }

      var company = companyId();
      var variant = currentVariantId(this);
      if (!company || !variant) {
        this.say(this.strings.error, 'error');
        return;
      }

      this.submit.disabled = true;

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              // Klaviyos katalog-id for en Shopify-variant.
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant }
            }
          }
        }
      };

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.status === 202 || r.ok) {
            this.say(this.strings.success, 'success');
            this.input.value = '';
            this.input.hidden = true;
            this.submit.hidden = true;
          } else {
            this.say(this.strings.error, 'error');
          }
        }.bind(this))
        .catch(function () {
          this.say(this.strings.error, 'error');
        }.bind(this))
        .finally(function () {
          this.submit.disabled = false;
        }.bind(this));
    }
  }

  if (!customElements.get('back-in-stock')) {
    customElements.define('back-in-stock', BackInStock);
  }
})();
